import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-placement-detail',
  templateUrl: './placement-detail.component.html',
  styleUrls: ['./placement-detail.component.css']
})
export class PlacementDetailComponent {
  userInfo: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<PlacementDetailComponent>
  ) { }
  
  ngOnInit() {
   
    this.userInfo=JSON.parse(window.localStorage.getItem('userInfo'));
   // localStorage.getItem("userInfo");
  }
  onNoClick(): void {
    this.dialog.close();
  }
}
